import React, { useEffect, useRef, useState } from 'react';
import { Box, Button, Collapse, IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const ChallengesFilter = ({
  tagList,
  selectedFilter,
  setSelectedFilter,
  onMyCampClick,
  onShowAllClick,
  onShowMostPopularClick,
  selectedTag,
  setSelectedTag,
  selected,
  showListWithTag,
  myCampSelected,
  allSelected,
  mostPopularSelected,
  tagSelected,
}) => {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef();
  const toggleDropdown = () => {
    setOpen(!open);
  };

  const handleTagClick = (tag) => {
    localStorage.setItem("tagsFilter",JSON.stringify({tag:tag,filter:'tag'}))
    if (selectedTag === tag) return;
    setSelectedTag(tag);
    setOpen(false);
  };

  useEffect(() => {
    if (selectedTag.length < 1) return;
    showListWithTag();
  }, [selectedTag]);

  const handleMyCampClick = () => {
    setOpen(false);
    onMyCampClick();
  };

  const handleLatestClick = () => {
    setOpen(false);
    onShowAllClick();
  };

  const handleTrendingClick = () => {
    setOpen(false);
    onShowMostPopularClick();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'column', lg: 'row' }, // Column on small and medium screens, row on large screens
        alignItems: 'center',
        backgroundColor: 'transparent',
        padding: '8px',
        borderRadius: '8px',
        gap: '8px',
        paddingTop: { xs: '20px', md: '60px' },
        position: 'relative', // Ensures dropdown content stays within bounds
      }}
      className="filterwrapped"
    >
      <Box
        sx={{
          display: 'flex',
          gap: '8px',
          justifyContent: 'center',
          paddingX: { xs: '8px', sm: '0px' },
          overflowX: { xs: 'auto', md: 'unset' },
          whiteSpace: { xs: 'nowrap', md: 'normal' },
        }}
      >
        <Button
          variant="contained"
          sx={{
            backgroundColor: myCampSelected ? '#321b6d' : 'white',
            color: myCampSelected ? 'white' : '#321b6d',
            textTransform: 'none',
            borderRadius: '25px',
            padding: { xs: '0px 10px', sm: '0px 20px' },
            fontWeight: '700',
            fontFamily: 'Open Sans, sans-serif',
            fontSize: { xs: '0.875rem', sm: '1rem' },
            '&:hover': { backgroundColor: '#321b6d', color: 'white' },
            minWidth: { xs: '100px', sm: 'auto' },
          }}
          className="darkfont_feed"
          onClick={handleMyCampClick}
        >
          ⛺ My Camp
        </Button>

        <Button
          variant="contained"
          sx={{
            backgroundColor: allSelected ? '#321b6d' : 'white',
            color: allSelected ? 'white' : '#321b6d',
            textTransform: 'none',
            borderRadius: '25px',
            padding: { xs: '0px 10px', sm: '0px 20px' },
            fontWeight: '700',
            fontFamily: 'Open Sans, sans-serif',
            fontSize: { xs: '0.875rem', sm: '1rem' },
            '&:hover': { backgroundColor: '#321b6d', color: 'white' },
            minWidth: { xs: '100px', sm: 'auto' },
          }}
          className="darkfont_feed"
          onClick={handleLatestClick}
        >
          💡 Latest
        </Button>

        <Button
          variant="contained"
          sx={{
            backgroundColor: mostPopularSelected ? '#321b6d' : 'white',
            color: mostPopularSelected ? 'white' : '#321b6d',
            textTransform: 'none',
            borderRadius: '25px',
            padding: { xs: '0px 10px', sm: '0px 20px' },
            fontWeight: '700',
            fontFamily: 'Open Sans, sans-serif',
            fontSize: { xs: '0.875rem', sm: '1rem' },
            '&:hover': { backgroundColor: '#321b6d', color: 'white' },
            minWidth: { xs: '100px', sm: 'auto' },
          }}
          className="darkfont_feed"
          onClick={handleTrendingClick}
        >
          💞 Trending
        </Button>
      </Box>

      {/* Dropdown Button */}
      <Box
        sx={{
          width: '100%',
          textAlign: 'center',
          marginTop: { xs: '16px', md: '0px' },
        }}
      >
        <Button
          variant="contained"
          endIcon={<ExpandMoreIcon />}
          onClick={toggleDropdown}
          ref={buttonRef}
          sx={{
            backgroundColor: open || tagSelected ? '#321b6d' : 'white',
            color: open || tagSelected ? 'white' : '#321b6d',
            textTransform: 'none',
            borderRadius: '25px',
            fontWeight: '700',
            fontFamily: 'Open Sans, sans-serif',
            fontSize: { xs: '0.875rem', sm: '1rem' },
            padding: { xs: '6px 12px', sm: '8px 20px' },
            '&:hover': { backgroundColor: '#321b6d', color: 'white' },
            minWidth: { xs: '100px', sm: 'auto' },
            maxWidth: { xs: '530px', md: '100%' },
            width: '100%',
          }}
          className="darkfont_feed"
        >
          What’s your interest? Explore our branches...
        </Button>

        {/* Dropdown Content */}
        <Collapse
          in={open}
          timeout="auto"
          unmountOnExit
          // sx={{ position: 'relative' }}
        >
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              gap: '12px',
              marginTop: '16px',
              padding: '16px',
              borderRadius: '8px',
              backgroundColor: 'white',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
              position: 'absolute',
              // top: '100%',
              left: '50%',
              transform: 'translateX(-50%)',
              // maxWidth: '95%',
              zIndex: 100,
              // width: buttonRef.current
              //   ? `${buttonRef.current.offsetWidth}px`
              //   : '100%', // Match button width
              width: '100%',
            }}
          >
            {tagList.map((category, key) => (
              <Box
                key={key}
                sx={{
                  padding: '15px 20px',
                  borderRadius: '30px',
                  boxShadow: '1px 1px 10px rgba(0, 0, 0, .1)',
                  border: '1px solid rgba(0, 0, 0, .1)',
                  backgroundColor:
                    selectedTag === category?.tag ? '#321b6d' : '#fff',
                  color: selectedTag === category?.tag ? 'white' : '#321b6d',
                  fontWeight: '700',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '16px',
                  fontFamily: 'Open Sans, sans-serif',
                  cursor: 'pointer',
                }}
                onClick={() => handleTagClick(category?.tag)}
              >
                {category?.tag}
              </Box>
            ))}
          </Box>
        </Collapse>
      </Box>
    </Box>
  );
};

export default ChallengesFilter;
